import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observe } from "mobx";
import { inject, observer } from "mobx-react";
import * as React from 'react';
import { Prompt, withRouter } from "react-router";
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import ButtonRow from "src/Components/ButtonRow";
import DataTable from "src/Components/DataTable";
import EInput, { EButton, EInputMask } from "src/Components/EInput";
import WellFooter from "src/Components/Footer/WellFooter";
import OpenArrow from "src/Components/OpenArrow/OpenArrow";
import {  IWellCloseReview, IWellCloseReviewExpense, IWellCloseReviewProduct, IWellIntervalCost, IWellIntervalCostExpense, IWellIntervalCostProduct } from "src/Interfaces/WellInterface";
import { MessageStore } from "src/Stores/Messages/Messages";
import { TestsStore } from "src/Stores/Tests/TestsStore";
import { WellsStore } from "src/Stores/Wells/WellsStore";
import WorkflowHeader from "../../WorkflowHeader";
import WellCloseButton from "../WellCloseButton";
import WellRevertCloseButton from "../WellRevertCloseButton";
import IntervalViewTable from "./IntervalViewTable";


interface ICostReallocation{
    sourceIntervalCostId: string;
    destIntervalCostId: string;
    amount: number;
}

interface ICostAllocation{
    intervalCostId: string;
    intervalType: string;
    subInt: string;
    fluidType: string;
    used: number;
    ordinal: number;
}

const mask = new EInputMask();
@inject('stores')
@observer
class IntervalCosts extends React.Component {
    public props: any;
    private WellsStore: WellsStore;
    private TestsStore: TestsStore;
    private MessageStore: MessageStore;
    private wellReviewDisposer: any;

    public state = {
        costAllocations: [] as ICostAllocation[],
        costReallocations: [] as ICostReallocation[],
        intervalNameChanges: [] as any[],
        intervalOpen: [] as boolean[],
        intervalTypes: [] as string[],
        isDirty: false,
        modalMode: 'product',
        modalOpen: false,
        modalRenameOpen: false,
        reviewTotal: undefined as IWellCloseReviewExpense | IWellCloseReviewProduct | undefined,
        testIntervals: [] as any[],
        wellCloseReview: undefined as unknown as IWellCloseReview,
    };
   public rows: any;

    constructor(props: any) {
        super(props);
        this.WellsStore = props.stores.WellsStore;
        this.MessageStore = props.stores.MessageStore;
        this.TestsStore = props.stores.TestsStore;
    }

    public componentDidMount() {
        this.createObserver();
        if (this.WellsStore.well) {
            this.WellsStore.getWellCloseReview();
        } else {
            this.WellsStore.getWellDetails(this.props.match.params.wellId)
                .then(() => {
                    this.WellsStore.getWellCloseReview();
                });
        }
        this.getIntervalTypes();
    }

    private disposeObservers() {
        this.wellReviewDisposer();
    }
    
    public componentWillUnmount() {
        this.disposeObservers();
    }

    private createObserver() {
        this.wellReviewDisposer = observe(this.WellsStore, 'wellCloseReview', change => {
            const testIntervals = this.getTestIntervals(change.newValue);
            this.setState({
                testIntervals,
                wellCloseReview: change.newValue
            });
            return change;
        });
    }

    private getTestIntervals = (wellCloseReview: IWellCloseReview) => {
        const { intervalCosts } = wellCloseReview;
        const returnInts = [] as any[];
        for (let i = intervalCosts.length - 1; i >= 0; i--) {
            const interval = returnInts.find(ri => ri.intervalType === intervalCosts[i].intervalType && ri.subInt === intervalCosts[i].subInt);
            if (!interval) {
                returnInts.push({ intervalType: intervalCosts[i].intervalType, subInt: intervalCosts[i].subInt});
            }
        }
        return returnInts;
    }
    private handleIntervalOpen = (index: number) => () => {
        const intervalOpen = this.state.intervalOpen;
        intervalOpen[index] = !intervalOpen[index];
        this.setState({
            intervalOpen,
        });
    }

    private getIntervalTypes() {
        this.TestsStore.getIntervalTypes()
        .then(
            (data: any) => {
                this.setState({
                    intervalTypes: data
                });
            }
        );
    }

    private collapseAllIntervals = () => {
        const intervalOpen = new Array(this.WellsStore.wellCloseReview.intervalCosts.length).fill(false);
        this.setState({intervalOpen});
    }

    private expandAllIntervals = () => {
        const intervalOpen = new Array(this.WellsStore.wellCloseReview.intervalCosts.length).fill(true);
        this.setState({intervalOpen});
    }


    private getIntervalProductsData = (products: IWellIntervalCostProduct[], intervalIndex: number) => {
        const headers = [
            'Product',
            'Size',
            'Unit',
            'Price',
            'Used (Reconciled)'
        ];

        const rows = products.map(value => 
            [
                {
                    content: value.product.name,
                },
                {
                    content: value.product.size,
                },
                {
                    content: value.product.unit,
                },
                {
                    content: mask.currency(value.price),
                    sortItem: value.price,
                },
                {
                    content: value.quantity,
                }
            ]
            );
        return { headers, rows};
    }

    private getIntervalExpenseData = (expenses: IWellIntervalCostExpense[], index: any) => {
        // const wellCloseReview = this.state.wellCloseReview;
        // const wcreId = wellCloseReview.expenses.map(wcr => wcr.expenseType.name); 
        // const newExpense = [] as IWellIntervalCostExpense[];
        // expenses.map( (a) => {
        //     const matched = wcreId.filter(b => b === a.expense.name);
        //     if (matched.length) {
        //         newExpense.push(a);
        //     } 
       // });
      
    
        const headers = [
            'Expense',
            'Type',
            'Unit Price',
            'Final Units',
        ];
        const rows = expenses.map(value =>
            [
                {
                    content: value.expense.name
                },
                {
                    content: value.expense.isRental ? 'Rental' : 'Service'

                },
                {
                    content: mask.currency(value.price),
                    sortItem: value.price,
                },
                {
                    content: value.quantity
                }
            ]);
        return { headers, rows };
    }

    public handleEditProduct = (intervalCostId: string) => (productIndex: number) => {
        const intervalCost = this.state.wellCloseReview.intervalCosts.find(ic => ic.id === intervalCostId);
        if (intervalCost === undefined) {
            return;
        }
        const intervalProduct = intervalCost.products[productIndex];
        const wellCloseReview = this.state.wellCloseReview;
        const wellCloseReviewProduct = wellCloseReview.products.find(p => p.productId === intervalProduct.product.id && p.price === intervalProduct.price);

        this.setState({
            modalMode: 'products',
            modalOpen: true,
            reviewTotal: wellCloseReviewProduct,
        });
    }

    public handleEditExpense = (intervalCostId: string) => (expenseIndex: number) => {
        const intervalCost = this.state.wellCloseReview.intervalCosts.find(ic => ic.id === intervalCostId);
        if (intervalCost === undefined) {
            return;
        }
        const intervalExpense = intervalCost.expenses[expenseIndex];
        const wellCloseReview = this.state.wellCloseReview;
        const wellCloseReviewExpense = wellCloseReview.expenses.find(ex => ex.expenseTypeId === intervalExpense.expense.id && ex.unitPrice === intervalExpense.price);
        this.setState({
            modalMode: 'expenses',
            modalOpen: true,
            reviewTotal: wellCloseReviewExpense,
        });
    }

    private saveModal = () => {
        const { costReallocations, modalMode, reviewTotal, wellCloseReview } = this.state;
        const intervalCosts = wellCloseReview.intervalCosts;
        if (modalMode === 'products') {
            const reviewProduct = reviewTotal as IWellCloseReviewProduct;
            costReallocations.forEach(value => {
                const sourceInterval = intervalCosts.find(ic => ic.id === value.sourceIntervalCostId);
                const destInterval = intervalCosts.find(ic => ic.id === value.destIntervalCostId);
                if (sourceInterval && destInterval) {
                    const sourceProduct = sourceInterval.products.find(p => p.product.id === reviewProduct.productId && p.price === reviewProduct.price);
                    const destProduct = destInterval.products.find(p => p.product.id === reviewProduct.productId && p.price === reviewProduct.price);
                    if (sourceProduct && destProduct) {
                        sourceProduct.quantity -= Number(value.amount);
                        destProduct.quantity += Number(value.amount);
                    } else if (sourceProduct) {
                        sourceProduct.quantity -= Number(value.amount);
                        destInterval.products.push({
                            id: "",
                            price: reviewProduct.price,
                            product: reviewProduct.product,
                            quantity: Number(value.amount),
                        });
                    }

                }
            });
        } else {
            const reviewExpense = reviewTotal as IWellCloseReviewExpense;
            costReallocations.forEach(value => {
                const sourceInterval = intervalCosts.find(ic => ic.id === value.sourceIntervalCostId);
                const destInterval = intervalCosts.find(ic => ic.id === value.destIntervalCostId);
                if (sourceInterval && destInterval) {
                    const sourceExpense = sourceInterval.expenses.find(e => e.expense.id === reviewExpense.expenseTypeId && e.price === reviewExpense.unitPrice);
                    const destExpense = destInterval.expenses.find(e => e.expense.id === reviewExpense.expenseTypeId && e.price === reviewExpense.unitPrice);
                    if (sourceExpense && destExpense) {
                        sourceExpense.quantity -= Number(value.amount);
                        destExpense.quantity += Number(value.amount);
                    } else if (sourceExpense) {
                        sourceExpense.quantity -= Number(value.amount);
                        destInterval.expenses.push({
                            expense: reviewExpense.expenseType,
                            id: "",
                            price: reviewExpense.unitPrice,
                            quantity: Number(value.amount),
                        });
                    }

                }
            });
        }
        
        this.setState({
            costReallocations: [],
            isDirty: true,
            modalMode: 'products',
            modalOpen: false,
            reviewTotal: undefined,
            wellCloseReview,
        }, () => {
            this.MessageStore.addMessage(
                'You successfully reallocated one or more inventory items.',
                'success'
            );
        });
    }

    private clearModal = () => {
        this.setState({
            costReallocations: [],
            modalMode: 'products',
            modalOpen: false,
            reviewTotal: undefined,
        });
    }

    private openRenameModal = () => {
        this.setState({
            modalRenameOpen: true,
        });
    }

    private clearModalRename = () => {
        this.setState({
            intervalNameChanges: [],
            modalRenameOpen: !this.state.modalRenameOpen,
        });
    }

    private updateSubInts = (intervals: any[]) => {
        const intervalTypes = {};
        for(let i = intervals.length - 1; i >= 0; i--) {
            const currInt = intervals[i];
            if (intervalTypes[currInt.intervalType]) {
                currInt.subInt = (++intervalTypes[currInt.intervalType]).toString();
            } else {
                intervalTypes[currInt.intervalType] = 1;
                currInt.subInt = "1";
            }
        }
    }

    private handleIntervalTypeChange = (index: number) => (event: any) => {
        const { intervalNameChanges, testIntervals, wellCloseReview } = this.state;
        const detachedIntervals = [];
        for (const interval of testIntervals) {
            const alreadyChanged = intervalNameChanges
                .find(inc => inc.oldType === interval.intervalType && inc.oldSub === interval.subInt);
            if (alreadyChanged) {
                detachedIntervals.push({
                    intervalType: alreadyChanged.intervalType,
                    oldType: alreadyChanged.oldType,
                    subInt: alreadyChanged.subInt,
                });
            } else {
                detachedIntervals.push({...interval});
            }
        }
        detachedIntervals[index].intervalType = event.target.value;
        this.updateSubInts(detachedIntervals);
        for (let i = 0; i < testIntervals.length; i++) {
            if (detachedIntervals[i].intervalType !== testIntervals[i].intervalType
                || detachedIntervals[i].subInt !== testIntervals[i].subInt ) {

                const intervalType = detachedIntervals[i].intervalType;
                const subInt = detachedIntervals[i].subInt;
                const currChange = intervalNameChanges
                    .find(inc => inc.oldType === testIntervals[i].intervalType
                        && inc.oldSub === testIntervals[i].subInt);
                
                if (currChange) {
                    currChange.intervalType = intervalType;
                    currChange.subInt = subInt;
                } else {
                    intervalNameChanges.push({ 
                        index: i,
                        intervalType,
                        oldSub: testIntervals[i].subInt,
                        oldType: testIntervals[i].intervalType,
                        subInt,
                        wellCloseReviewId: wellCloseReview.id,
                    });
                }
            }
        }
        this.setState({
            intervalNameChanges
        });
    }

    private handleSaveIntervalTypeChanges = () => {
        const { wellCloseReview, testIntervals, intervalNameChanges } = this.state;
        for (const intervalCost of wellCloseReview.intervalCosts) {
            const { intervalType, subInt } = intervalCost;
            const changeInterval = intervalNameChanges
                .find(inc => inc.oldType === intervalType && inc.oldSub === subInt);
            if (changeInterval) {
                intervalCost.intervalType = changeInterval.intervalType;
                intervalCost.oldIntervalType = changeInterval.oldType;
                intervalCost.subInt = changeInterval.subInt;
                intervalCost.oldSubInt = changeInterval.oldSub;
                wellCloseReview.id = changeInterval.wellCloseReviewId;
            }
        }

        for (const intervalChange of intervalNameChanges) {
            testIntervals[intervalChange.index].intervalType = intervalChange.intervalType;
            testIntervals[intervalChange.index].subInt = intervalChange.subInt;
            testIntervals[intervalChange.index].oldType = intervalChange.oldType;
        }

        this.setState({
            intervalNameChanges: [],
            modalRenameOpen: false,
            testIntervals,
            wellCloseReview
        });
    }

    private renderIntervalCost = (intervalCost: IWellIntervalCost, index: any) => {
        const productData = this.getIntervalProductsData(intervalCost.products, index);
       const expenseData = this.getIntervalExpenseData(intervalCost.expenses, index);
        return (
    <React.Fragment>
        <Row>
            <Col>
                <h4 className="accordian-h4">
                    <span onClick={this.handleIntervalOpen(index)}>
                        <OpenArrow open={this.state.intervalOpen[index]}/>
                        {' '}
                        {intervalCost.intervalType}
                        {' '}
                        {intervalCost.subInt}
                        {' '}
                        | {intervalCost.fluidType}
                    </span>
                </h4>
            </Col>
        </Row>
        {
            this.state.intervalOpen[index] && 
            <Row>
                <Col>
                    <DataTable
                        list={productData}
                        onEdit={this.handleEditProduct(intervalCost.id)}
                    />
                </Col>
            </Row>
        }
        {
            this.state.intervalOpen[index] && 
            <Row>
                <Col>
                    <DataTable
                            list={expenseData}
                        onEdit={this.handleEditExpense(intervalCost.id)}
                    />
                </Col>
            </Row>
        }
    </React.Fragment>
        );
    }

    private renderReviewTotal = (reviewTotal: IWellCloseReviewExpense | IWellCloseReviewProduct | undefined) => {
        if (reviewTotal === undefined) {
            return { headers: [], rows: []};
        }
        if (this.state.modalMode === 'products') {
            const reviewProduct = reviewTotal as IWellCloseReviewProduct;
            const headers = [
                'Product Name',
                'Size',
                'Unit',
                'Price',
                'Total Used'
            ];

            const rows = [
                [
                    reviewProduct.product.name,
                    reviewProduct.product.size,
                    reviewProduct.product.unit,
                    mask.currency(reviewProduct.price),
                    reviewProduct.totalUsed - reviewProduct.credited, 
                ]
            ];
            return { headers, rows };
        } else {
            const reviewExpense = reviewTotal as IWellCloseReviewExpense;
            const headers = [
                'EBP Item',
                'Unit Price',
                'Total Units',
            ];

            const rows = [
                [
                    reviewExpense.expenseType.name,
                    reviewExpense.unitPrice,
                    reviewExpense.totalUnits,
                ]
            ];

            return { headers, rows };

        }
    }

    private getCurrentAllocations = () => {
        const { costReallocations, modalMode, reviewTotal, wellCloseReview } = this.state;
        if (reviewTotal === undefined) {
            return [];
        }
        const intervalCosts = wellCloseReview.intervalCosts;
        const costAllocations = intervalCosts.map((value, index) => {
            if (modalMode === 'products') {
                const reviewProduct = reviewTotal as IWellCloseReviewProduct;
                const intervalProduct = value.products.find(p => p.product.id === reviewProduct.productId && p.price === reviewProduct.price);
                if (intervalProduct) {
                    return {
                        fluidType: value.fluidType,
                        intervalCostId: value.id,
                        intervalType: value.intervalType,
                        oldIntervalType: value.oldIntervalType,
                        oldSubInt: value.oldSubInt,
                        ordinal: index,
                        subInt: value.subInt,
                        used: intervalProduct.quantity
                    };
                }
            } else {
                const reviewExpense = reviewTotal as IWellCloseReviewExpense;
                const intervalExpense = value.expenses.find(e => e.expense.id === reviewExpense.expenseTypeId && e.price === reviewExpense.unitPrice);
                if (intervalExpense) {
                    return {
                        fluidType: value.fluidType,
                        intervalCostId: value.id,
                        intervalType: value.intervalType,
                        oldIntervalType: value.oldIntervalType,
                        oldSubInt: value.oldSubInt,
                        ordinal: index,
                        subInt: value.subInt,
                        used: intervalExpense.quantity
                    };
                }
            }
            return undefined;
        }).filter(val => val !== undefined) as ICostAllocation[];

        costReallocations.forEach(value => {
            const sourceIntervalCost = costAllocations.find(ic => ic.intervalCostId === value.sourceIntervalCostId);
            const destIntervalCost = costAllocations.find(ic => ic.intervalCostId === value.destIntervalCostId);
            if (sourceIntervalCost) {
                sourceIntervalCost.used -= Number(value.amount);
            } 
            if (destIntervalCost) {
                destIntervalCost.used += Number(value.amount);
            }
        });
        return costAllocations;
    }

    private addNewReallocation = () => {
        const costReallocations = this.state.costReallocations;
        costReallocations.push({amount: 0, sourceIntervalCostId: '', destIntervalCostId: ''});
        this.setState({
            costReallocations,
        });
    }

    private handleSourceDestUpdate = (index: number) => (event: any) => {
        const costReallocations = this.state.costReallocations;
        const currCR = costReallocations[index];
        currCR[event.target.name] = event.target.value;
        this.setState({
            costReallocations,
        });
    }

    private handleAmountUpdate = (index: number) => (event: any) => {
        const costReallocations = this.state.costReallocations;
        const currCR = costReallocations[index];
        currCR.amount = event.target.value;
        this.setState({
            costReallocations,
        });

    }

    private handleReallocationDelete = (index: number) => () => {
        const costReallocations = this.state.costReallocations;
        costReallocations.splice(index, 1);
        this.setState({
            costReallocations,
        });
    }

    private filterIntervalCosts = (intervalCost: IWellIntervalCost) => {
        const { modalMode, reviewTotal } = this.state;
        if (modalMode === 'products') {
            const reviewProduct = reviewTotal as IWellCloseReviewProduct;
            const intervalProduct = intervalCost.products.find(p => p.product.id === reviewProduct.productId && p.price === reviewProduct.price);
            return intervalProduct !== undefined;
        } else {
            const reviewExpense = reviewTotal as IWellCloseReviewExpense;
            const intervalExpense = intervalCost.expenses.find(e => e.expense.id === reviewExpense.expenseTypeId && e.price === reviewExpense.unitPrice);
            return intervalExpense !== undefined;
        }
    }

    private decimalAmountsAllowed = () => {
        const { modalMode, reviewTotal } = this.state;
        if (modalMode === 'products') {
            const reviewProduct = reviewTotal as IWellCloseReviewProduct;
            return reviewProduct.product.isBulk;
        }
        return false;
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        if ( $target.name === 'previousButton' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/wellclose/ebpreview');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/wellclose/volumeaccountingreview');
        }
    }

    private updateWellCloseReview = () => {
        this.WellsStore.saveWellCloseReview(this.state.wellCloseReview)
            .then(data => {
                if (data) {
                    this.setState({
                        isDirty: false
                    });
                }
            });
    }

    public render() {
        const { costReallocations, modalOpen, modalMode, reviewTotal, testIntervals, wellCloseReview } = this.state;
        return (
        <div>
            <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
            <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} isInventoryReport={false}/>
            <Row>
                <IntervalViewTable />
            </Row>
            <Row style={{marginBottom: '0.5rem'}}>
                <Col>
                    <Button color="primary" onClick={this.expandAllIntervals}>Expand All Intervals</Button>
                    {' '}
                    <Button color="primary" onClick={this.collapseAllIntervals}>Collapse All Intervals</Button>
                </Col>
            </Row>
            <Row style={{marginBottom: '0.5rem'}}>
                <Col>
                    <Button color="primary" onClick={this.openRenameModal}>Rename Intervals</Button>
                </Col>
            </Row>
            {
                this.state.wellCloseReview && this.state.wellCloseReview.intervalCosts.map((value, index) => 
                    <React.Fragment key={value.id}>
                        {
                            this.renderIntervalCost(value, index)
                        }
                    </React.Fragment>
                )
            }
            <ButtonRow>
                <WellRevertCloseButton />
                <WellCloseButton />
                { this.WellsStore.canUpdateWell() && <EButton color="primary" name="save" onClick={this.updateWellCloseReview}>Save</EButton>}
                <Button className="secondary" name="previousButton" onClick={this.buttonNavigation}>Previous</Button>
                <Button className="secondary" name="nextButton" onClick={this.buttonNavigation}>Next</Button>
                <WellFooter />
            </ButtonRow>
            <Modal size="lg" isOpen={modalOpen} toggle={this.clearModal} backdrop="static">
                <ModalHeader toggle={this.clearModal}>
                    Reallocate {modalMode === 'products' ? 'Product' : 'EBP'}
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <DataTable
                                list={this.renderReviewTotal(reviewTotal)}
                            />
                        </Col>
                    </Row>
                    {
                        this.getCurrentAllocations().map((value, index) => 
                                <Row key={index}>
                                    <Col>
                                        <FormGroup>
                                            <Label>Interval</Label>
                                            <Input
                                                type="text"
                                                value={ `${value.intervalType} ${value.subInt}`}
                                                disabled={true}
                                                />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label>Fluid Type</Label>
                                            <Input
                                                type="text"
                                                value={ value.fluidType}
                                                disabled={true}
                                                />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label>Used</Label>
                                            <EInput
                                                type="text"
                                                value={ value.used }
                                                data-validation="decimal"
                                                disabled={true}
                                                />
                                        </FormGroup>
                                    </Col>
                                </Row>
                        )
                    }
                    {
                        costReallocations.map((value, index) => 
                            <Row key={index}>
                                <Col>
                                    <FormGroup className="required">
                                        <Label>From</Label>
                                        <EInput
                                            type="select"
                                            name="sourceIntervalCostId"
                                            value={value.sourceIntervalCostId}
                                            required={true}
                                            onChange={this.handleSourceDestUpdate(index)}
                                        >
                                            <option />
                                            {
                                                wellCloseReview.intervalCosts.filter(this.filterIntervalCosts).map(val =>
                                                    <option key={val.id} value={val.id}>{val.intervalType} {val.subInt} | {val.fluidType}</option>
                                                )
                                            }
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup className="required">
                                        <Label>To</Label>
                                        <EInput
                                            type="select"
                                            name="destIntervalCostId"
                                            value={value.destIntervalCostId}
                                            required={true}
                                            onChange={this.handleSourceDestUpdate(index)}
                                        >
                                            <option />
                                            {
                                                wellCloseReview.intervalCosts.filter(ic => ic.id !== value.sourceIntervalCostId).map(val =>
                                                    <option key={val.id} value={val.id}>{val.intervalType} {val.subInt} | {val.fluidType}</option>
                                                )
                                            }
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup className="required">
                                        <Label>Amount</Label>
                                        <EInput
                                            type="text"
                                            name="amount"
                                            value={value.amount}
                                            required={true}
                                            data-validation={this.decimalAmountsAllowed() ? "decimal" : "integer"}
                                            decimal-places="2"
                                            onChange={this.handleAmountUpdate(index)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="1">
                                    <div style={{marginTop: '1rem'}} onClick={this.handleReallocationDelete(index)}>
                                        <FontAwesomeIcon icon={faTrashAlt} size="2x" />
                                    </div>  
                                </Col>
                            </Row>
                        )
                    }
                    <Row>
                        <Col>
                            <Button color="primary" onClick={this.addNewReallocation}>New Reallocation</Button>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button className="secondary" onClick={this.clearModal}>Cancel</Button>
                    <EButton color="primary" onClick={this.saveModal}>Save</EButton>
                </ModalFooter>
            </Modal>
            <Modal size="lg" isOpen={this.state.modalRenameOpen} toggle={this.clearModalRename} backdrop="static">
                <ModalHeader toggle={this.clearModal}>
                    Rename Intervals
                </ModalHeader>
                <ModalBody>
                    {
                        testIntervals &&
                        testIntervals.map((int, i) =>                        
                        <Row key={int.id} style={{marginBottom: '0.5rem'}}>
                            <Col sm={6}>
                                Current: {int.intervalType} {int.subInt}
                            </Col>
                            <Col sm={6}>
                                <EInput
                                    type="select"
                                    name="intervalType"
                                    id="intervalType"
                                    required={true}
                                    value={ 
                                        this.state.intervalNameChanges.find(inc => inc.index === i) ?
                                        this.state.intervalNameChanges.find(inc => inc.index === i).intervalType
                                        : int.intervalType
                                    }
                                    onChange={this.handleIntervalTypeChange(i)}
                                >
                                    <option value="" />
                                    { this.state.intervalTypes && this.state.intervalTypes.map((intervalType: string ,index: number) =>
                                        <option key={index} value={intervalType}>{intervalType}</option>
                                    ) }
                                </EInput>
                            </Col>
                        </Row>
                        )
                    }
                </ModalBody>
                <ModalFooter>
                    <Button className="secondary" onClick={this.clearModalRename}>Cancel</Button>
                    <Button color="primary" onClick={this.handleSaveIntervalTypeChanges}>Save</Button>
                </ModalFooter>
            </Modal>
        </div>
        );
    }

}

export default withRouter(IntervalCosts);


// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellClose/IntervalCosts.tsx